import { render, staticRenderFns } from "./ucgamedata.vue?vue&type=template&id=1f8e2689&scoped=true"
import script from "./ucgamedata.vue?vue&type=script&lang=js"
export * from "./ucgamedata.vue?vue&type=script&lang=js"
import style0 from "./ucgamedata.vue?vue&type=style&index=0&id=1f8e2689&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f8e2689",
  null
  
)

export default component.exports